import { getRequest } from 'utilities/service.utils';
import LocateService from './locate.service.context';
import createUrlBuilder from 'utilities/url.builder.utils';

export const getSystemJob = async (
  params: any,
  id: number | undefined = undefined
) => {
  const urlBuilder = createUrlBuilder(`/systemjob/getJob${id ? `/${id}` : ''}`);
  urlBuilder.addParameter('type', params.type);
  return await getRequest(LocateService, urlBuilder.toString());
};
